<div style="padding-top: 20px; padding-bottom: 20px">
  <div>Montag - Donnerstag 09:00 bis 15:00 und Freitag von 09:00 - 14:00</div>

  <div class="flex-wrap" style="margin-top: 20px; margin-left: 20px">
    <mng-out label="Telefon">
      <div class="text-important">
        <a href="tel:0800220309">0800 22 03 09</a>
      </div>
    </mng-out>

    <mng-out label="E-Mail">
      <a href="mailto:{{ reservierungMail() }}">{{ reservierungMail() }}</a>
    </mng-out>
  </div>
</div>
